/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import { colors } from '@lmc/common/constants'
import { getNominative } from 'common/utils'
import { Gallery, GalleryItem } from 'components/Gallery'
import dayjs from 'dayjs'
import _ from 'lodash'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Icon } from '../../generic/Icon'
import LinkComponent from '../LinkComponent/LinkComponent'
import { Popup, SuInvolved, VideoEl, VideoThumbnail } from '../LogSharedStyles'
import VideoPreview from '../VideoPreview'
import Description from './Description'

function LogTimelineRow(props) {
  const { mock = false, log, dateFormat, testId, index } = props
  const role = useSelector((state) => state.global.user.role)
  const preferredPeopleNominative = useSelector(
    (state) => state.global.home.preferredPeopleNominative
  )

  const [isVideoOpen, setIsVideoOpen] = useState(false)
  const toggleVideoPopup = () => setIsVideoOpen((v) => !v)

  const isDisabled = role === 'senior-carer' || mock === true
  const isDeleted = log.deleted

  const { videoThumbnail, videoFile } = log

  const opacity = log.deleted && 0.2
  const baseId = testId ? `${testId}-row-${index}` : `log-timeline-row-${index}`

  const pictures = [log.picture1, log.picture2, log.picture3].filter((p) => p)
  const isSignatureLog = log?.item?.itemId === 'signature'
  const nominative = getNominative(preferredPeopleNominative, 'Service user')

  const getCarerName = (log) => {
    if (log.carerName) return log.carerName
    if (log?.loggedBy && log?.loggedBy.name)
      return `${log?.loggedBy.name.first} ${log?.loggedBy.name.last}`
    return 'Carer'
  }

  const getWitnessName = (log) => {
    if (log.witnessedBy) {
      if (log.witnessedBy.name)
        return `${log.witnessedBy.name.first} ${log.witnessedBy.name.last}`
      return log.witnessedBy
    }
    return 'Carer'
  }

  const renderWitnessedBy = (log) => {
    const offset = log.picture1 ? 15 : 0
    const editedAt = dayjs(log.editedAt).subtract(offset, 'seconds')
    const isEdited = log.editedAt && dayjs(log.timeLogged).isBefore(editedAt)

    if (isEdited) {
      const name = _.isObject(log.editedBy && log.editedBy.name)
        ? `${log.editedBy.name.first} ${log.editedBy.name.last}`
        : log.editedBy
      return (
        <div>
          <EditedByText>
            {`${log.deleted ? `Removed by` : `Edited by`} ${name} on ${dayjs(
              log.editedAt
            ).format('DD-MM-YYYY')}`}
          </EditedByText>
        </div>
      )
    }
    return null
  }

  const renderIcon = (log, isPDF) => {
    const dotStyle = {
      width: 44,
      height: 44,
      border: '3px solid rgba(0,0,0,0)',
      borderRadius: 24,
      backgroundColor: colors.grey,
      marginRight: 18,
      marginLeft: 12,
      marginTop: 6,
      alignItems: 'center',
      ...(!isPDF && {
        backgroundColor: log.deleted
          ? colors.grey
          : log.categoryColor || log.category.color
      }),
      ...(isPDF && { backgroundColor: 'transparent' })
    }
    const fallback =
      'https://cdn2.iconfinder.com/data/icons/business-office-14/256/5-128.png'
    const image =
      _.get(log, 'itemIcon.url') ||
      _.get(log, 'categoryIcon.url') ||
      _.get(log, 'item.icon') ||
      _.get(log, 'category.icon') ||
      fallback
    return (
      <div style={dotStyle} className="lmc-timeline-dot">
        <div
          className="lmc-dot-icon"
          style={{
            background: `url(${image})`,
            backgroundSize: '14px !important',
            backgroundPosition: 'center center !important'
          }}
        />
      </div>
    )
  }

  const renderSubHeader = (log, dateFormat) => {
    const logSavedAt = dayjs(log.originalTimeLog)
      .subtract(15, 'seconds')
      .format()
    const isTimeLogged = dayjs(log.timeLogged).format()
    const dayLogSavedTimedAt = dayjs(log.originalTimeLog).format('D')
    const dayLogChangedTimeAt = dayjs(log.timeLogged).format('D')
    const isSameDay = dayLogChangedTimeAt === dayLogSavedTimedAt

    let smallText = ''

    if (log.originalTimeLog) {
      if (logSavedAt > isTimeLogged) {
        if (isSameDay) {
          smallText += `, logged at: ${dayjs(log.originalTimeLog).format(
            'HH:mm'
          )}`
        } else {
          smallText += `, logged at: ${dayjs(log.originalTimeLog).format(
            'DD/MM/YY HH:mm'
          )}`
        }
      }
    }

    if (log.witnessedBy) {
      smallText += `, witnessed by ${getWitnessName(log)}`
    }

    return (
      <SmallText className="lmc-timeline-date">
        {dayjs(log.timeLogged).format(dateFormat || 'HH:mm')} -{' '}
        {getCarerName(log)}
        <span style={{ opacity: 0.7 }}>{smallText}</span>
      </SmallText>
    )
  }

  return (
    <MainContainer key={log.id} data-testid={baseId}>
      <LinkComponent
        disabled={isDisabled}
        to={`/logs/${log.id}`}
        className="lmc-timeline-link"
        data-testid={`${baseId}-link`}
      >
        <Container>
          <LogRow>
            <div data-testid={`${baseId}-icon`}>
              {renderIcon(log, props.isPDF)}
            </div>
            <div data-testid={`${baseId}-content`}>
              {renderSubHeader(log, dateFormat)}
              <TitleText
                style={{
                  color: isDeleted ? colors.darkgrey : null
                }}
                data-testid={`${baseId}-title`}
              >
                {isDeleted ? `Log Removed` : log.title}
              </TitleText>
              <Description
                isDeleted={isDeleted}
                description={log.description}
                testId={`${baseId}-description`}
              />
              {renderWitnessedBy(log)}
              {log.doneBySu && (
                <SuInvolved data-testid={`${baseId}-su-involved`}>
                  {nominative} was involved in writing this log
                </SuInvolved>
              )}
            </div>
          </LogRow>
        </Container>
      </LinkComponent>
      <div
        style={{ marginLeft: 85, paddingBottom: 15 }}
        data-testid={`${baseId}-media`}
      >
        <GalleryWrapper data-testid={`${baseId}-gallery`}>
          <Gallery>
            {!isSignatureLog
              ? pictures.map((url, idx) => (
                  <GalleryItem
                    key={url}
                    src={url}
                    alt="Log photo"
                    style={{
                      opacity,
                      height: 100,
                      borderRadius: 10,
                      marginTop: 8,
                      marginRight: 8,
                      background: colors.background,
                      cursor: 'pointer',
                      display: props.isPDF ? 'none' : 'inline'
                    }}
                    width={749}
                    height={1000}
                    data-testid={`${baseId}-picture-${idx}`}
                  />
                ))
              : log?.picture1 && (
                  <GalleryItem
                    key={log?.picture1}
                    src={log?.picture1}
                    alt="Signature log photo"
                    style={{
                      opacity,
                      height: '100px',
                      borderRadius: '10px',
                      marginTop: '8px',
                      marginRight: '8px',
                      background: '#f0f0f0',
                      cursor: 'pointer'
                    }}
                    width={749}
                    height={230}
                    data-testid={`${baseId}-signature-picture`}
                  />
                )}
          </Gallery>
        </GalleryWrapper>
        {videoFile && (
          <VideoThumbnail
            onClick={(e) => {
              e.stopPropagation()
              toggleVideoPopup()
            }}
            style={{ position: 'relative' }}
            data-testid={`${baseId}-video-thumbnail`}
          >
            <Icon
              name="play"
              fill={colors.white}
              size={32}
              style={{
                position: 'absolute',
                marginTop: 40,
                marginLeft: 20
              }}
            />
            <VideoPreview
              videoFile={videoFile}
              videoThumbnail={videoThumbnail}
              testId={`${baseId}-video-thumbnail-image`}
              style={{
                height: 100,
                width: 75,
                borderRadius: 10,
                marginTop: 8,
                marginRight: 8,
                background: colors.background,
                cursor: 'pointer'
              }}
            />
          </VideoThumbnail>
        )}

        {isVideoOpen && (
          <Popup
            content={
              <VideoEl controls>
                <source src={videoFile} type="video/mp4" />
                <track
                  src="captions_en.vtt"
                  kind="captions"
                  label="english_captions"
                />
              </VideoEl>
            }
            handleClose={(e) => {
              toggleVideoPopup()
              e.stopPropagation()
            }}
          />
        )}
      </div>
    </MainContainer>
  )
}

export { LogTimelineRow }
export default LogTimelineRow

const Container = styled.div`
  padding: 12px;
  padding-bottom: 0;
`

const EditedByText = styled.p`
  color: ${colors.darkgrey};
  font-size: 11px;
  margin-top: 1px;
`

const GalleryWrapper = styled.div`
  align-items: center;
  display: inline;
  gap: 12px;
  margin-top: 8px;
`

const LogRow = styled.div`
  align-items: left;
  display: flex;
  flex-direction: row;
  margin: 0;
`

const MainContainer = styled.li`
  background: ${colors.white};
  border-radius: 15px;
  margin-bottom: 12px;
`

const SmallText = styled.div`
  color: ${colors.darkgrey};
  font-size: 12px;
`

const TitleText = styled.h3`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 0;
`
